import React, { useState } from 'react'
import { IonPage, IonHeader, IonToolbar, IonLabel, IonContent, IonIcon, IonCol, IonRow, IonItem, IonSelectOption, IonSelect, IonInput, IonButton, IonTitle, useIonViewDidLeave, useIonViewDidEnter, IonButtons, IonModal, IonBackButton } from '@ionic/react';
import { menuController, loadingController } from '@ionic/core';
import { trash, create } from 'ionicons/icons';
import moment from 'moment';
import UpdateCustomer from '../UpdateCutomer';
import ErrorBox from '../../ErrorBox';
import CustomerLedgerTable from './CustomerLedgerTable';
import { useCustomerDetails } from './useCustomerDetail';
const CustomerDetail = ({ match, history }) => {
    const name = atob(match.params.name)

    const { addToLedger, printLedger, printVoucher, deleteCustomer , removeFromLedger,
        date, setDate, setAmt, debit, credit, balance, alert , setAlert, editable , seteditable,
        CustomerDetail, setCustomerDetail, Ledger, setLedger,
        
    } = useCustomerDetails(name)

    const [ModelOpen, setModelOpen] = useState(false)

    useIonViewDidEnter(() => {
        menuController.enable(true, 'LedgerMenu');
        loadingController.dismiss('true', undefined, "ledgerLoad")
    })

    useIonViewDidLeave(async () => {
        let x = await menuController.get('LedgerMenu');
        x && sessionStorage.removeItem('currentParty');
    })


    const AddinLedger = (
        <div hidden={!editable}>
            <h5 className='red-text'>Add in Ledger</h5>
            <form onSubmit={addToLedger}>
                <IonRow>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='stacked'>Date</IonLabel>
                            <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                        </IonItem>
                        <IonButton type='submit' color='danger' className='ion-padding '>Add</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Amount</IonLabel>
                            <IonInput type='number' id="amt" min='0' step='any' required onIonInput={e => { setAmt(parseFloat(e.target.value)) }} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Amount Type</IonLabel>
                            <IonSelect interface='popover' id='type'>
                                <IonSelectOption value="credit">Credit / Receivable</IonSelectOption>
                                <IonSelectOption value="debit">Debit / Payable</IonSelectOption>
                            </IonSelect>
                        </IonItem>
                    </IonCol>
                </IonRow>
            </form>
        </div>
    )

    if (!CustomerDetail.id) {
        return (
            <ErrorBox alert={alert} setAlert={setAlert} />
        )
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Ledger Details - <span style={{ textTransform: 'capitalize' }}>{name}</span></IonTitle>

                    <IonButtons slot='end' hidden={!editable}>
                        <IonButton onClick={() => setModelOpen(true)}>
                            <IonIcon icon={create}></IonIcon>
                            <IonLabel>Edit</IonLabel>
                        </IonButton>

                        <IonButton onClick={async () => {
                            await deleteCustomer()
                            history.replace('/ledger')

                        }} >
                            <IonIcon icon={trash}></IonIcon>
                            <IonLabel>Remove Ledger</IonLabel>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent className='ion-padding'>



                <IonRow>
                    <IonCol>
                        <h5 style={{ textTransform: 'capitalize' }}>{CustomerDetail.customerName}</h5>
                        <p>{CustomerDetail.customerContact ? CustomerDetail.customerContact : ""}</p>
                        <p>{CustomerDetail.customerDetails ? CustomerDetail.customerDetails : ""}</p>
                        {CustomerDetail.customerGST ? (
                            <p>GST No. {CustomerDetail.customerGST ? CustomerDetail.customerGST : ""}</p>
                        ) : ('')}
                    </IonCol>
                    <IonCol offset='5' class='ion-align-self-end'>
                        <p className="">Debit  : &#8377; {debit.toFixed(2)}</p>
                        <p className="">Credit : &#8377; {credit.toFixed(2)}</p>
                        <h5>Balance : &#8377; {balance.toFixed(2)}</h5>
                    </IonCol>
                </IonRow>

                {/* <PaginatedLedgerTable Ledger={Ledger} editable={editable} printVoucher={printVoucher} removeFromLedger={removeFromLedger} /> */}
                <CustomerLedgerTable CustomerLedger={Ledger} editable={editable} printVoucher={printVoucher} removeFromLedger={removeFromLedger} />

                <IonRow className='ion-justify-content-center'>
                    <IonButton color='danger' onClick={printLedger}>Print</IonButton>
                </IonRow>

                {AddinLedger}

            </IonContent>

            <IonModal isOpen={ModelOpen} cssClass='addCustomer' onDidDismiss={() => setModelOpen(false)} >
                <UpdateCustomer setModelOpen={setModelOpen} data={CustomerDetail} setdata={setCustomerDetail} />
            </IonModal>
            <iframe className="ion-hide" id="print" title="Print Invoice"></iframe>

        </IonPage>
    )
}

export default CustomerDetail
